import * as d3 from "d3";
import ViewState from "../viewState";
import MathUtil from "../../utils/mathUtil";
import Positioning from "../../utils/drawing/positioningUtil";
export default class Hulls {
    constructor(mpointMap) {
        this._svg = mpointMap.overlay;
        this._mpointMap = mpointMap;
    }
    update() {
        const _this = this;
        const hulls = Array.from(ViewState.hulls.values()).map(function (hull) {
            const coordinates = [], mps = [];
            ViewState.mPointMarkers.filter(mp => mp.hullId === hull.treeNodeId)
                .forEach(mp => {
                coordinates.push([mp.x, mp.y]);
                mps.push(mp._mpoint);
            });
            const xs = coordinates.map(coord => coord[0]), ys = coordinates.map(coord => coord[1]);
            const hullBox = {
                x: Math.min(...xs),
                y: Math.min(...ys),
                width: Math.max(...xs) - Math.min(...xs),
                height: Math.max(...ys) - Math.min(...ys)
            };
            if (coordinates.length > 2) {
                if (hullBox.width < 2)
                    hullBox.width = 2;
                if (hullBox.height < 2)
                    hullBox.height = 2;
            }
            const midP = [
                MathUtil.average([Math.min(...xs), Math.max(...xs)]),
                MathUtil.average([Math.min(...ys), Math.max(...ys)]),
            ];
            const ratio = mps.length / _this._mpointMap.mPointMarkersInView.length;
            return {
                name: hull.name,
                color: hull.color,
                vortex: _this.hullPoints(coordinates),
                box: hullBox,
                midpoint: midP,
                mpointRatio: ratio,
                size: hullBox.width * hullBox.height,
                mpoints: mps
            };
        })
            .filter(h => h.vortex && h.vortex.length > 0 &&
            Positioning.areOverlapping(h.box, _this._mpointMap.getBox()))
            .sort((a, b) => b.mpointRatio - a.mpointRatio);
        Hulls.hullSelection = this._svg.select("#hullGroup")
            .selectAll(".hull")
            .data(hulls, h => h.name);
        Hulls.hullSelection.exit().remove();
        Hulls.hullSelection = Hulls.hullSelection
            .enter().append("path")
            .attr("class", "hull")
            .attr("fill", (hull) => hull.color)
            .attr("stroke", hull => hull.color)
            .on("click", function (event, hull) {
            event.stopPropagation();
            _this._mpointMap.zoomToFitMarkers.call(_this._mpointMap, hull.mpoints);
        })
            .merge(Hulls.hullSelection);
        Hulls.hullSelection
            .attr("d", function (d) {
            const vortex = d.vortex;
            const ls = vortex.join("L");
            return `M${ls}Z`;
        });
        Hulls.hullHeaderSelection = this._svg.select("#hullHeadersGroup")
            .selectAll(".hullHeader")
            .data(hulls, h => h.name);
        Hulls.hullHeaderSelection.exit().remove();
        Hulls.hullHeaderSelection = Hulls.hullHeaderSelection
            .enter().append("text")
            .attr("class", "hullHeader")
            .text(hull => hull.name)
            .style("mask", (d, i) => `url(#maskHullHeader${i})`)
            .merge(Hulls.hullHeaderSelection);
        Hulls.hullHeaderSelection
            .style("font-size", hull => {
            const em = Math.min(2, .7 + 5 * hull.mpointRatio);
            return `${em.toPrecision(2)}em`;
        })
            .each(function (hull, i, nodes) {
            const node = nodes[i];
            const labelsBefore = [];
            for (let j = 0; j < i; j++)
                labelsBefore.push(nodes[j]);
            const boxInit = node.getBBox();
            function getLabelBox(xCenter, yCenter) {
                return { x: xCenter - boxInit.width / 2, y: yCenter - boxInit.height, width: boxInit.width, height: boxInit.height };
            }
            const xOrig = hull.midpoint[0], yOrig = hull.midpoint[1], a = .05, b = .1, overlapPadding = 5;
            let xNew = xOrig, yNew = yOrig, angle = 0, //spiraling settings
            labelBox;
            const debugPathData = new Array();
            //Spiral out from midpoint until finding place where label doesn't overlap an mpoint 
            let textPlaceCleared = false;
            while (!textPlaceCleared) {
                labelBox = getLabelBox(xNew, yNew);
                const overlappingMarker = ViewState.mPointMarkers.find(mpm => Positioning.areOverlapping({
                    x: mpm.x - mpm.r,
                    y: mpm.y - mpm.r,
                    width: 2 * mpm.r,
                    height: 2 * mpm.r
                }, labelBox, overlapPadding));
                const overlappingLabel = labelsBefore.find(lblBefore => Positioning.areOverlapping(lblBefore.getBBox(), labelBox, overlapPadding));
                if (overlappingMarker || overlappingLabel) {
                    angle += .1;
                    xNew = xNew + (120 * a + b * angle) * Math.cos(angle); //öka a -> spiralen utdragen i x-led
                    yNew = yNew + (a + b * angle) * Math.sin(angle);
                    debugPathData.push({ x: xNew, y: yNew });
                }
                else
                    textPlaceCleared = true;
            }
            //this.drawDebugSwirl(debugPathData, i);
            const mapSize = _this._mpointMap.mapSize();
            const closeEnough = Positioning.areOverlapping(labelBox, hull.box, 20), bigEnoughHull = hull.size > mapSize / 1000 ||
                i < 3 ||
                !hulls.some(superHull => superHull.size > hull.size &&
                    Positioning.areOverlapping(superHull.box, hull.box, 20) &&
                    superHull.size < mapSize / 4);
            const xAttr = document.createAttribute("x"), yAttr = document.createAttribute("y"), xAlign = document.createAttribute("text-anchor"), yAlign = document.createAttribute("alignment-baseline");
            if (closeEnough && bigEnoughHull) {
                xAttr.value = xNew.toString();
                yAttr.value = yNew.toString();
                xAlign.value = "middle";
                yAlign.value = "middle";
            }
            else
                [xAttr, yAttr, xAlign, yAlign]
                    .forEach(attr => {
                    attr.value = "";
                });
            [xAttr, yAttr, xAlign, yAlign]
                .forEach(attr => {
                node.attributes.setNamedItem(attr);
            });
        });
    }
    hullPoints(points) {
        if (points.length < 3)
            return points;
        return d3.polygonHull(points);
    }
}
